import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation RenderItemEmailMutation($input: RenderItemEmailInput!) {
        renderItemEmail(input: $input) {
            clientMutationId
        }
    }
`;

const commit = (environment, args) => {
    const {
        message,
        recipientEmails,
        senderEmail,
        senderName,
        itemId,
        onCompleted,
        onError,
    } = args;

    const input = { message, recipientEmails, senderEmail, senderName, itemId };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
